import React, {useState, useEffect, useRef, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Pagination, Tabs, DatePicker, Spin, Input, Divider} from 'antd';
import {searchPage} from '@/api/conversation';
import ContentCard from '@/page/conversation/ConPage/Content/ContentCard';
import UserDetail from '@/page/conversation/ConPage/UserDetail';
import styles from './card.module.less';
import '@/util/dayjsInit';
import dayjs from 'dayjs';
import _ from 'lodash';
// import InfiniteScroll from 'react-infinite-scroll-component';

const {RangePicker} = DatePicker;
const {Search} = Input;

const {TabPane} = Tabs;

const tabs = [
    {name: '全部', key: ''},
    {name: '图片', key: 'image'},
    {
        name: '视频',
        key: 'video',
    },
    {name: '文件', key: 'file'},
    {name: '链接', key: 'link'},
    {name: '位置', key: 'location'},
    {name: '红包', key: 'redpacket'},
    {name: '互通红包', key: 'external_redpacket'},
    {name: '语音输入', key: 'voice'},
    {name: '语音通话', key: 'meeting_voice_call'},
    {name: '视频号', key: 'sphfeed'},
    // {name: '语音通话文件', key: 'voip_doc_share'},
];

function Content({receiveType, from, receive, fromType}) {
    const userDetailRef = useRef();
    const [current, setCurrent] = useState(1);
    const [total, setTotal] = useState(0);
    const [contents, setContents] = useState([]);
    const [msgType, setMsgType] = useState('');
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(dayjs().format('YYYY-MM-DD HH:mm:ss'));
    const [start, setStart] = useState(dayjs().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss'));
    const [keyword, setKeyword] = useState('');
    const [msgTimeStart, setMsgTimeStart] = useState('');
    const [msgTimeEnd, setMsgTimeEnd] = useState('');
    const [preMsgId, setPreMsgId] = useState([]);

    useEffect(() => {
        setLoading(true);
        if (!_.isEmpty(from) && !_.isEmpty(receive)) {
            initData();
        } else {
            setContents([]);
            setTotal(0);
            setCurrent(1);
            setLoading(false);
        }
    }, [current, receiveType, from, receive, msgType, keyword, start, end]);

    function initData() {
        let to = '';
        let fromId = '';
        let chatId = '';
        if (receiveType !== 3 && receiveType !== 4 && receiveType !== 5) {
            // 员工发起得对话
            if (fromType === 0) {
                fromId = from.extId;
                // 非群聊得员工与客户对话/非群聊得员工间对话
                to = receiveType === 1 ? receive.externalUserId : receive.extId;
            } else {
                // 客户与员工得对话
                fromId = from.externalUserId;
                to = receive.extId;
            }
        } else chatId = receive.chatId;
        let searchParam = {
            to: to,
            from: fromId,
            type: 1,
            keyword: keyword,
            msgtype: msgType,
            roomid: chatId,
            start: new Date(start).getTime(),
            end: new Date(end).getTime(),
            page: current,
            size: 10,
        };
        searchPage(searchParam).then(res => {
            if (!_.isEmpty(res.data) && res.data.records.length > 0) {
                setTotal(res.data.total);
                setCurrent(res.data.current);
                setLoading(false);
                setMsgTimeStart(
                    dayjs(parseInt(res.data.records[0].msgtime)).format('YYYY.MM.DD HH:mm:ss')
                );
                setMsgTimeEnd(
                    dayjs(parseInt(res.data.records[res.data.records.length - 1].msgtime)).format(
                        'YYYY.MM.DD HH:mm:ss'
                    )
                );
                /**
                 * 查询结果需要做特殊处理,撤回消息 要找到撤回的内容 语音会议要要找到对应的分配
                 */
                let resData = [];
                let pre = [...preMsgId];
                let tempDoc = [];
                for (let i = 0; i < res.data.records.length; i++) {
                    const val = res.data.records[i];
                    const type = val.msgtype;
                    if (pre.includes(val.msgid)) {
                        continue;
                    }
                    if (type === 'revoke') {
                        // 撤回消息
                        val.premsg = res.data.records[i + 1];
                        pre.push(res.data.records[i + 1].msgid);
                    }
                    if (type === 'voip_doc_share') {
                        // 语音会议分享消息
                        tempDoc.push(val);
                        continue;
                    }
                    if (type === 'text' && val.text.content === '【未知消息类型】') {
                        // 语音会议分享消息中的杂项
                        continue;
                    }
                    resData.push(val);
                }
                // 额外需要对语音会议及docshare文件进行合并
                let finalData = [];
                resData.forEach(item => {
                    const msgtype = item.msgtype;
                    if (msgtype === 'meeting_voice_call') {
                        const {voiceid} = item;
                        const docShare = tempDoc.filter(v => v.voipid === voiceid);
                        item.docShare = docShare;
                    }
                    finalData.push(item);
                });
                console.log('final', finalData);
                // setContents([...contents, ...finalData]);
                setContents(finalData.reverse());
                setPreMsgId(pre);
            } else {
                setTotal(0);
                setCurrent(1);
                setContents([]);
                setLoading(false);
                setMsgTimeStart('');
                setMsgTimeEnd('');
            }
        });
    }

    function changePage(page, size) {
        setCurrent(page);
    }

    function changeTab(key) {
        // setCurrent(1);
        // setContents([]);
        // setTotal(0);
        setMsgType(key);
    }

    function changeDate(date, dateStr) {
        // setCurrent(1);
        // setContents([]);
        // setTotal(0);
        setStart(dateStr[0] + ' 00:00:00');
        setEnd(dateStr[1] + ' 23:59:59');
    }

    function onSearch(e) {
        // setCurrent(1);
        // setContents([]);
        // setTotal(0);
        setKeyword(e);
    }

    function openDetail(userDetail) {
        userDetailRef.current.open(userDetail);
    }

    function loadMore() {
        initData();
    }

    function renderFilter() {
        const dateFormat = 'YYYY-MM-DD';
        return (
            <div className={styles.filter}>
                <Search placeholder="请输入..." size="large" onSearch={onSearch} />
                <RangePicker
                    className={styles.rangePick}
                    size="large"
                    onChange={changeDate}
                    defaultValue={[dayjs(start, dateFormat), dayjs(end, dateFormat)]}
                />
            </div>
        );
    }

    function renderTabs() {
        return (
            <Tabs defaultActiveKey="0" onChange={changeTab} className={styles.tab}>
                {tabs.map((item, i) => (
                    <TabPane tab={item.name} key={item.key}>
                        <Spin spinning={loading}>
                            {renderFilter()}
                            {typeof receive !== 'undefined' && (
                                <Fragment>
                                    {/*<div*/}
                                    {/*    id={'scrollableDiv_' + item.key}*/}
                                    {/*    style={{*/}
                                    {/*        height: '80vh',*/}
                                    {/*        overflow: 'auto',*/}
                                    {/*        // padding: '0 5px',*/}
                                    {/*        // border: '1px solid rgba(140, 140, 140, 0.35)',*/}
                                    {/*    }}*/}
                                    {/*>*/}
                                    {/*<InfiniteScroll*/}
                                    {/*    dataLength={contents.length}*/}
                                    {/*    next={loadMore}*/}
                                    {/*    hasMore={contents.length < total}*/}
                                    {/*    endMessage={<Divider plain>已经加载全部</Divider>}*/}
                                    {/*    scrollableTarget={'scrollableDiv_' + item.key}*/}
                                    {/*>*/}
                                    <div
                                        className={classNames(styles.time, {
                                            [styles.hidden]: msgTimeStart === '',
                                        })}
                                    >
                                        {msgTimeEnd}
                                    </div>
                                    {renderContents()}
                                    <div
                                        className={classNames(styles.time, {
                                            [styles.hidden]: msgTimeEnd === '',
                                        })}
                                    >
                                        {msgTimeStart}
                                    </div>
                                    {/*</InfiniteScroll>*/}
                                    {/*</div>*/}
                                </Fragment>
                            )}
                        </Spin>
                    </TabPane>
                ))}
            </Tabs>
        );
    }

    function renderContents() {
        return (
            <div className={styles.container}>
                {contents.length > 0 &&
                    contents.map((content, key) => (
                        <ContentCard
                            openDetail={receiveType === 3 ? openDetail : () => {}}
                            key={key}
                            content={content}
                            from={from}
                            fromType={fromType}
                            receive={
                                receiveType === 3
                                    ? !_.isEmpty(receive.memberList) &&
                                      receive.memberList.find(item => item.extId === content.from)
                                    : receive
                            }
                        />
                    ))}
            </div>
        );
    }

    return (
        <Fragment>
            {renderTabs()}
            <div className={styles.page}>
                <Pagination
                    defaultCurrent={1}
                    defaultPageSize={10}
                    total={total}
                    current={current}
                    onChange={changePage}
                    hideOnSinglePage={true}
                />
            </div>
            <UserDetail ref={userDetailRef} />
        </Fragment>
    );
}

Content.propTypes = {
    receiveType: PropTypes.number,
    fromType: PropTypes.number,
    receive: PropTypes.object,
    from: PropTypes.object,
};

export default Content;
